<template>
       <div class="loader">
          <span aria-hidden="true" class="spinner-border"></span>
      </div>
</template>
<script>
export default {
    name: 'Loader'
}
</script>